module.exports = __webpack_public_path__ + "static/media/cd.d4408d3c.svg";